import {
  ABG_NO_DESTINATION_NOTE_FOR_RA,
  ABG_REPLACEMENT_CAR_COMMENT, ABG_TRANSPORTATION_COMMENT
} from "../../app-consts/appConstants";

export function processVehicleComment(
  existingComment: string,
  newPayload: string,
): string {

  const baseComment = ABG_NO_DESTINATION_NOTE_FOR_RA;
  const replacement = ABG_REPLACEMENT_CAR_COMMENT;
  const transportation = ABG_TRANSPORTATION_COMMENT;

  const normalizedExisting = existingComment?.trim() ?? "";
  const normalizedPayload = newPayload?.trim() ?? "";

  const isEmptyPayload = normalizedPayload === "";
  const isSpecial =
    normalizedPayload === replacement ||
    normalizedPayload === transportation;

  //Empty payload
  if (isEmptyPayload) {
    return normalizedExisting.includes(baseComment) ? baseComment : "";
  }

  if (!normalizedExisting) {
    return normalizedPayload;
  }

  const includesReplacement = normalizedExisting.includes(replacement);
  const includesTransportation = normalizedExisting.includes(transportation);

  if (isSpecial) {
    if (
      normalizedExisting === baseComment ||
      includesReplacement ||
      includesTransportation
    ) {
      return `${baseComment}, ${normalizedPayload}`;
    }
    return `${normalizedExisting}, ${normalizedPayload}`;
  }

  //Default append (avoid duplicates)
  return normalizedExisting.includes(normalizedPayload)
    ? normalizedExisting
    : `${normalizedExisting}, ${normalizedPayload}`;
}
